export default __webpack_public_path__ + "static/media/SettingsRed.076af91a.svg";